/* product-carousel-manual.js */
(function () {
  function initCarousels() {
    document.querySelectorAll('.product-carousel__outer[data-section-id]').forEach(function (outer) {
      // Prevent double init (theme editor reloads / multiple calls)
      if (outer.dataset.carouselInit === 'true') return;
      outer.dataset.carouselInit = 'true';

      var track = outer.querySelector('.product-carousel__track');
      var prevBtn = outer.querySelector('.product-carousel__nav--prev');
      var nextBtn = outer.querySelector('.product-carousel__nav--next');

      // Progress sits outside outer (same parent as outer)
      var progressThumb = outer.parentElement.querySelector('.product-carousel__progress-thumb');

      if (!track || !prevBtn || !nextBtn) return;

      /* =========================
         CAROUSEL SCROLL
         ========================= */
      function getScrollAmount() {
        var card = track.querySelector('.product-carousel__card');
        if (!card) return 300;
        var rect = card.getBoundingClientRect();
        var gap = parseFloat(getComputedStyle(track).gap) || 0;
        return rect.width + gap;
      }

      function scrollByDir(dir) {
        track.scrollBy({
          left: dir * getScrollAmount(),
          behavior: 'smooth'
        });
      }

      prevBtn.addEventListener('click', function () { scrollByDir(-1); });
      nextBtn.addEventListener('click', function () { scrollByDir(1); });

      function updateUI() {
        var maxScrollLeft = track.scrollWidth - track.clientWidth;

        // Arrow states
        var atStart = track.scrollLeft <= 1;
        var atEnd = track.scrollLeft >= (maxScrollLeft - 1);

        prevBtn.classList.toggle('is-hidden', atStart);
        nextBtn.classList.toggle('is-hidden', atEnd);

        prevBtn.disabled = atStart;
        nextBtn.disabled = atEnd;

        // Tab-style progress thumb
        if (progressThumb) {
          var progressTrack = progressThumb.parentElement;
          var trackWidth = progressTrack.clientWidth;

          if (maxScrollLeft <= 0) {
            progressThumb.style.width = '100%';
            progressThumb.style.transform = 'translate(0, -50%)';
          } else {
            var progressRatio = track.scrollLeft / maxScrollLeft;
            var visibleRatio = track.clientWidth / track.scrollWidth;
            var thumbWidth = Math.max(80, Math.round(trackWidth * visibleRatio));
            progressThumb.style.width = thumbWidth + 'px';

            var maxTranslate = Math.max(0, trackWidth - thumbWidth);
            var translateX = maxTranslate * progressRatio;

            progressThumb.style.transform = 'translate(' + translateX + 'px, -50%)';
          }
        }
      }

      function rafUpdate() {
        requestAnimationFrame(updateUI);
      }

      track.addEventListener('scroll', rafUpdate, { passive: true });
      window.addEventListener('resize', rafUpdate);

      updateUI();
      setTimeout(updateUI, 150);
      setTimeout(updateUI, 600);

      /* =========================
         AJAX ADD TO CART (NO REDIRECT)
         - Do NOT disable button
         - Show "Added" briefly then revert to original label
         ========================= */

      function setBtnText(btn, text) {
        if (!btn) return;
        btn.textContent = text;
      }

      function ensureDefaultLabel(btn) {
        if (!btn) return '';
        if (!btn.getAttribute('data-default-label')) {
          btn.setAttribute('data-default-label', btn.textContent.trim());
        }
        return btn.getAttribute('data-default-label') || btn.textContent.trim();
      }

      function updateHeaderCartCount(cart) {
        if (!cart || typeof cart.item_count !== 'number') return;
        var count = cart.item_count;

        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = String(count);
        });

        var bubble = document.querySelector('.cart-count-bubble span');
        if (bubble) bubble.textContent = String(count);

        document.querySelectorAll('.cart-count, .header__cart-count, .header-cart-count').forEach(function (el) {
          el.textContent = String(count);
        });
      }

      function refreshCartCount() {
        return fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateHeaderCartCount(cart);
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
            return cart;
          })
          .catch(function () { /* ignore */ });
      }

      function ajaxAddToCart(form, btn) {
        var defaultLabel = ensureDefaultLabel(btn);
        var addedLabel = (btn && btn.getAttribute('data-added-label')) || 'Added';

        // prevent double-click spam while request is running (but don't disable)
        if (btn && btn.dataset.atcLoading === 'true') return;
        if (btn) btn.dataset.atcLoading = 'true';

        // UI feedback
        if (btn) {
          btn.classList.add('is-loading');
          setBtnText(btn, 'Adding...');
        }

        var fd = new FormData(form);

        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' },
          body: fd
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (e) { throw e; });
            return res.json();
          })
          .then(function () {
            // Success: show "Added" briefly, then revert
            if (btn) {
              btn.classList.remove('is-loading');
              btn.classList.add('is-added');
              setBtnText(btn, addedLabel);

              clearTimeout(btn._atcRevertTimer);
              btn._atcRevertTimer = setTimeout(function () {
                btn.classList.remove('is-added');
                setBtnText(btn, defaultLabel);
              }, 1200);
            }

            return refreshCartCount();
          })
          .catch(function (err) {
            console.warn('Add to cart failed', err);
            if (btn) {
              btn.classList.remove('is-loading');
              btn.classList.remove('is-added');
              setBtnText(btn, 'Try again');

              clearTimeout(btn._atcRevertTimer);
              btn._atcRevertTimer = setTimeout(function () {
                setBtnText(btn, defaultLabel);
              }, 1500);
            }
          })
          .finally(function () {
            if (btn) btn.dataset.atcLoading = 'false';
          });
      }

      // Attach submit listeners for ATC forms inside this carousel section
      outer.querySelectorAll('form.product-carousel__atc-form').forEach(function (form) {
        if (form.dataset.atcInit === 'true') return;
        form.dataset.atcInit = 'true';

        form.addEventListener('submit', function (e) {
          e.preventDefault();
          e.stopPropagation();

          var btn = form.querySelector('button[type="submit"]');
          if (!btn) return;

          ajaxAddToCart(form, btn);
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initCarousels);

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.product-carousel__outer[data-section-id]').forEach(function (outer) {
      outer.dataset.carouselInit = 'false';
    });
    document.querySelectorAll('form.product-carousel__atc-form').forEach(function (f) {
      f.dataset.atcInit = 'false';
    });
    initCarousels();
  });
})();
